<template>
  <div>
    <div class="container">
      <h2 class="font-weight-bold font-size-medium text-center">Publicações com a tag: <span class="text-color2">{{ tag.name }}</span></h2>
    </div>
    <!-- TABS -->
    <section class="mt-5">
      <div class="container">

        <b-tabs
            content-class="mt-4 mt-lg-5"
            nav-class="default-tabs font-size-lg-medium"
          >
          <!-- PUBLICATIONS TAB -->
          <b-tab title="Publicações" active>
            <div v-if="posts.length > 0">
                <PostThumbList
                  class="mt-4"
                  :posts="posts"
                />
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderPosts"
                    @click="loadMorePosts"
                    v-if="isLoadMorePostsVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
            <Loader
              color="color2"
              size="big"
              v-else-if="loaderPosts"
            />
            <p class="text-center mt-4" v-else>Não foi encontrada nenhuma publicação para essa busca</p>
          </b-tab>

          <!-- BOOKS TAB -->
          <b-tab title="Livros">
            <div v-if="books.length > 0">
                <BookThumbList
                  :books="books"
                  class="mt-4"
                />
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderBooks"
                    @click="loadMoreBooks"
                    v-if="isLoadMoreBooksVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
            </div>
            <Loader
              color="color2"
              size="big"
              v-else-if="loaderBooks"
            />
            <p class="text-center mt-4" v-else>Não foi encontrado nenhum livro para essa busca</p>
          </b-tab>
        </b-tabs>
      </div>
    </section> <!-- END TABS -->
  </div>
</template>

<script>

import PostsService from '@/modules/posts/services/posts-service'
import BooksService from '@/modules/books/services/books-service'
import TagsService from '@/modules/tags/services/tags-service'

import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'
import PostThumbList from '@/components/post/PostThumbList.vue'
import BookThumbList from '@/components/books/BookThumbList.vue'

export default {
  components: {
    Button,
    Loader,
    PostThumbList,
    BookThumbList
  },
  data () {
    return {
      slug: this.$route.params.slug,
      tag: {
        id: '',
        name: '',
        slug: ''
      },
      posts: [],
      books: [],
      pagePosts: 1,
      pageBooks: 1,
      loaderPosts: false,
      loaderBooks: false,
      isLoadMorePostsVisible: true,
      isLoadMoreBooksVisible: true
    }
  },
  metaInfo () {
    return {
      title: `Tag ${this.tag.name}`
    }
  },
  created () {
    this.resetAndStart()
  },
  watch: {
    '$route' (to, from) {
      this.slug = to.params.slug
      this.resetAndStart()
    }
  },
  methods: {
    resetAndStart () {
      this.pagePosts = 1
      this.pageBooks = 1
      this.posts = []
      this.books = []
      this.tag.id = ''
      this.tag.name = ''
      this.tag.slug = ''
      this.getTag()
    },
    async getTag () {
      try {
        const tag = await TagsService.getTag(this.slug)
        this.tag = tag
        this.getPosts()
        this.getBooks()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getPosts  () {
      this.loaderPosts = true
      try {
        const posts = await PostsService.getPosts({ tagId: this.tag.id, page: this.pagePosts })
        this.posts = [...this.posts, ...posts]
        this.isLoadMorePostsVisible = posts.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderPosts = false
    },
    async getBooks () {
      this.loaderBooks = true
      try {
        const books = await BooksService.getBooks({ tagId: this.tag.id, page: this.pageBooks })
        this.books = [...this.books, ...books]
        this.isLoadMoreBooksVisible = books.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderBooks = false
    },
    loadMorePosts () {
      this.pagePosts++
      this.getPosts()
    },
    loadMoreBooks () {
      this.pageBooks++
      this.getBooks()
    }
  }
}
</script>
